import axios from "axios"
import http from "./http"

export async function getLookupApi({ token }) {
    try {
        const payload = { 
            profile_id: 715
        }
        const response = await http(true).post('/v1_4/custom/pco/lookup/list', payload, {
            headers: {
                token
            }
        })
        if (response.code !== '200') throw 'error get lookup'
        return response?.data
    } catch (error) {
        throw error
    }
}

export async function getResult({ task_id, token }) {
    try {
        const payload = { 
            profile_id: 715,
            task_id,
        }
        const response = await http(true).post('/v1_4/custom/pco/result/get', payload, {
            headers: {
                token
            }
        })
        if (response.code !== '200') throw 'error get lookup'
        return response?.data
    } catch (error) {
        throw error
    }
}

export async function saveServiceTreatmentApi({ task_id, service_treatment, token }) {
    try {
        const payload = { 
            profile_id: 715,
            task_id,
            service_treatment,
        }
        const response = await http(true).post('/v1_4/custom/pco/result/treatment', payload, {
            headers: {
                token
            }
        })
        if (response.code !== '200') throw 'error save service treatment'
        return response?.data
    } catch (error) {
        throw error
    }
}

export async function saveRecommendationApi({ task_id, recomendation, is_checked, token, user_name }) {
    try {
        const payload = { 
            profile_id: 715,
            task_id,
            recomendation,
            is_checked,
            user_name,
        }
        const response = await http(true).post('/v1_4/custom/pco/result/recommendation', payload, {
            headers: {
                token
            }
        })
        if (response.code !== '200') throw 'error save recommendation'
        return response?.data
    } catch (error) {
        throw error
    }
}

export async function saveResultAllApi({ task_id, recomendation, service_treatment, is_checked, token, user_name }) {
    try {
        const payload = { 
            profile_id: 715,
            task_id,
            recomendation,
            service_treatment,
            is_checked,
            user_name,
        }
        const response = await http(true).post('/v1_4/custom/pco/result/all', payload, {
            headers: {
                token
            }
        })
        if (response.code !== '200') throw response
        return response?.data
    } catch (error) {
        throw error
    }
}

export async function countWithAi({ image }) {
    const formData = new FormData()
    formData.set('image_data', image)
    const response = await axios.post('https://collectionv2.jari.co.id/api/ocr/pest-helper', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-Application-Key': '91e1a73429229f0ab19f7cd473f2df18',
            'X-Application-Secret': 'JDEMO_f66878e514b26d589957fe23e96ebb4658e2ce06a1841818358a70c214257001.546e78072f9be65a21b3bbd16693941b20437185d47e53aa6d5f1c913acbd46fb79068a440668adbef0b67bc9a76cfa74d8aa96a8d12243177bf692ab389ab57.UC_5c064837ba45c1cc3c3a66a84b413740ea6af6a8969a10cfd3f76bcf32b871ee'
        }
    })
    return response?.data
}

export async function countFlies({ file }) {
    const formData = new FormData()
    formData.set('file', file)
    const response = await axios.post('https://flytrap.arappservice.online/count-flies/', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
    return response?.data
}

export async function flyCatcherDetect({ file, token, task_code }) {
    const formData = new FormData()
    formData.set('image', file)
    formData.set('task_code', task_code)
    formData.set('profile_id', '715')
    formData.set('return_image', '0')
    const response = await http(true).post('/v1_4/flycatcher/detect', formData, {
        headers: {
            token,
            'Content-Type': 'multipart/form-data',
        }
    })
    return response?.data
}

export async function flyCatcherTriggerScan({ token, date, task_code }) {
    const formData = new FormData()
    formData.set('profile_id', '715')
    formData.set('datetime', date)
    formData.set('vendor', 'roboflow')
    const response = await http(true).post('/v1_4/fly-catcher/trigger-count', formData, {
        headers: {
            token,
            'Content-Type': 'multipart/form-data',
        }
    })
    return response?.data
}